import React, { useState } from 'react';
import { Plus, Search, Shield, User, MoreHorizontal, Settings2 } from 'lucide-react';

export default function UsersPermissions() {
    const [searchQuery, setSearchQuery] = useState('');

    const mockUsers = [
        { id: 1, name: "Vishal Suryavanshi", email: "vishal@oblique.com", role: "Superadmin", department: "Executive", lastActive: "Just now" },
        { id: 2, name: "Sanjay Dev", email: "sanjay@oblique.com", role: "Admin", department: "Engineering", lastActive: "5 mins ago" }
    ];

    return (
        <div className="animate-fade-in max-w-5xl">
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-1">Users & Permissions</h2>
                    <p className="text-sm text-[var(--text-tertiary)]">Manage workspace members, their roles, and access controls across modules.</p>
                </div>
                <button className="flex items-center gap-2 px-4 py-2 bg-[var(--primary)] text-white text-sm font-medium rounded-lg hover:bg-[var(--primary-hover)] transition-colors">
                    <Plus size={16} />
                    Invite User
                </button>
            </div>

            <div className="bg-[var(--bg-surface)] border border-[var(--border)] rounded-xl overflow-hidden shadow-sm">
                <div className="flex items-center gap-4 p-4 border-b border-[var(--border)] bg-[var(--bg-subtle)]">
                    <div className="relative flex-1 max-w-sm">
                        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-tertiary)]" />
                        <input
                            type="text"
                            placeholder="Search users..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-full pl-9 pr-4 py-2 bg-[var(--bg-surface)] border border-[var(--border)] rounded-lg text-sm text-[var(--text-primary)] outline-none focus:border-[var(--primary)] transition-colors"
                        />
                    </div>
                    <button className="flex items-center gap-2 px-3 py-2 bg-[var(--bg-surface)] border border-[var(--border)] text-[var(--text-secondary)] text-sm font-medium rounded-lg hover:bg-[var(--bg-hover)] transition-colors">
                        <Settings2 size={15} />
                        Filter
                    </button>
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="border-b border-[var(--border)] bg-[var(--bg-subtle)]/50">
                                <th className="py-3 px-6 text-xs font-semibold text-[var(--text-tertiary)] uppercase tracking-wider">User</th>
                                <th className="py-3 px-6 text-xs font-semibold text-[var(--text-tertiary)] uppercase tracking-wider">Role</th>
                                <th className="py-3 px-6 text-xs font-semibold text-[var(--text-tertiary)] uppercase tracking-wider">Department</th>
                                <th className="py-3 px-6 text-xs font-semibold text-[var(--text-tertiary)] uppercase tracking-wider">Last Active</th>
                                <th className="py-3 px-6 text-xs font-semibold text-[var(--text-tertiary)] uppercase tracking-wider text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-[var(--border)]">
                            {mockUsers.map(user => (
                                <tr key={user.id} className="hover:bg-[var(--bg-hover)] transition-colors group">
                                    <td className="py-3 px-6">
                                        <div className="flex items-center gap-3">
                                            <div className="w-8 h-8 rounded-full bg-[var(--bg-muted)] flex items-center justify-center text-[var(--text-secondary)] font-medium text-xs">
                                                {user.name.split(' ').map(n => n[0]).join('')}
                                            </div>
                                            <div>
                                                <div className="text-sm font-medium text-[var(--text-primary)]">{user.name}</div>
                                                <div className="text-xs text-[var(--text-tertiary)]">{user.email}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="py-3 px-6">
                                        <div className="flex items-center gap-1.5">
                                            {user.role === 'Superadmin' || user.role === 'Admin' ? (
                                                <Shield size={14} className="text-[var(--primary)]" />
                                            ) : (
                                                <User size={14} className="text-[var(--text-tertiary)]" />
                                            )}
                                            <span className="text-sm text-[var(--text-secondary)]">{user.role}</span>
                                        </div>
                                    </td>
                                    <td className="py-3 px-6 text-sm text-[var(--text-secondary)]">
                                        {user.department}
                                    </td>
                                    <td className="py-3 px-6 text-sm text-[var(--text-tertiary)]">
                                        {user.lastActive}
                                    </td>
                                    <td className="py-3 px-6 text-right">
                                        <button className="p-1.5 text-[var(--text-tertiary)] hover:text-[var(--text-primary)] rounded-md hover:bg-[var(--bg-muted)] transition-colors opacity-0 group-hover:opacity-100">
                                            <MoreHorizontal size={16} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
